import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter as Router} from "react-router-dom";

import {Provider} from "react-redux";
import {store} from "./store/store";

import "./styles/reset.scss";
import "./styles/index.scss";

import {App} from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <Router>
      <App/>
    </Router>
  </Provider>
);
